import React, { useEffect, useState } from 'react';
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Swiper from 'swiper';
import SlidingVideosCart from './SlidingVideosCart';
import './SlidingVideos.css'

import io from "socket.io-client";
const socket = io.connect("https://mayapurapp.ap-1.evennode.com");


const SlidingVideos = () => {
      const [data, setData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  const openImage = (img) => setSelectedImage(img);
  const closeImage = () => setSelectedImage(null);

  // 🔹 Fetch products
  useEffect(() => {
      socket.emit("retrieveAllVideos");
      socket.on("allVideosRetrieved", (data) => {
        setData(data);
      });
    }, []);

  // 🔹 Init Swiper (AUTO + MANUAL)
  useEffect(() => {
    if (!data.length) return;

    const swiper = new Swiper(".multiple-slide-carousel", {
      modules: [Autoplay, Navigation],
      loop: true,
      spaceBetween: 20,

      autoplay: {
        delay: 2500,
        disableOnInteraction: false, // 🔥 auto continues
      },

      navigation: {
        nextEl: "#slider-button-right",
        prevEl: "#slider-button-left",
      },

      preventClicks: true,
      preventClicksPropagation: true,

      breakpoints: {
        0: { slidesPerView: 1 },
       520: { slidesPerView: 2 },
        640: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 5 },
      },
    });

    return () => swiper.destroy();
  }, [data]);

    const loopData = [...data, ...data];
    
  return (
      <div>
          <div >
      <div>
        <div className="forYouLR-wrapper">
          <div className="forYouLR-track">
            {loopData?.map((item, index) => (
              <div key={index} className="forYouLR-item">
                <SlidingVideosCart item={item} openImage={openImage} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default SlidingVideos;